import { StatusMap, SubStatusMap } from '@/config/SensorStatuses';

class SensorStatusHelper {

    static getColourHex(status) {
        switch(status) {
            case 0:
                return '#CCC'
            case 1:
                return `#111`
            case 2:
                return '#172B4D'
            case 3:
                return '#172B4D'
            case 4:
                return '#58CC95'
            case 5:
                return '#CC0000'
            case 6:
                return '#FF8B33'
            case 7:
                return '#172B4D'
            case 8:
                return '#111'
        }
    }

    static getDescription(status) {
        if(!status.status) return 'No status'
        return `${StatusMap[status.status]} ${status.subStatus ? `(${SubStatusMap[status.subStatus]})` : ``}`
    }
    
    static getColour(status, subStatus) {
        switch(status) {
            case 0:
                return 'light'
            case 1:
                switch(subStatus) {
                    case 11:
                        return 'dark'
                }
            case 2:
                return 'primary'
            case 3:
                return 'primary'
            case 4:
                return 'success'
            case 5:
                return 'danger'
            case 6:
                return 'warning'
            case 7:
                return 'primary'
            case 8:
                return 'dark'
        }
    }

  static getIcon(status, subStatus) {
    switch(status) {
        case null:
            return 'question-circle'
        case 1:
            switch(subStatus) {
                case 11:
                    return 'tools'
            }
            return 'tools'
        case 2:
            return 'dolly-flatbed'
        case 3:
            return 'shipping-fast'
        case 4:
            return 'thumbs-up'
        case 5:
            switch(subStatus) {
                case 51:
                    return 'tools'
                case 52:
                    return 'power-off'
                case 53:
                    return 'battery-empty'
                case 54:
                    return 'bahai'
                case 55:
                    return 'wifi'
                case 56:
                    return 'tired'
            }
            return 'exclamation-circle'
        case 6:
            switch(subStatus) {
                case 61:
                    return 'wifi'
            }
            return 'bug'
        case 7:
            return 'home'
        case 8:
            return 'skull-crossbones'
    }
  }

  

}

export { SensorStatusHelper };
